import { faAward } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { CERTIFICATION } from '../../../constants/props';
import Detail from '../../common/detail';

const View = ({ title, institution, year }) => {
  return (
    <Detail
      icon={<FontAwesomeIcon icon={faAward} />}
      title={title}
      subtitle={`${year} | ${institution}`}
    />
  );
};

View.propTypes = {
  CERTIFICATION,
};

export default View;
